import { Media } from 'components/Media/Media';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    getMaterials,
    getMaterialsClear,
    getMaterialsIdle,
} from 'store/ducks/materials/actions';
import { materialsSelector } from 'store/ducks/materials/selectors';
import MaterialsCard from './components/materialsCard';
import MaterialsCardText from './components/materialsCardText';
import MaterialsCardText2 from './components/materialsCardText2';
import PostArticles from './components/postArticles';
import NotFoundPage from "pages/404/404"
import Select from 'react-select';
import './Materials.css';
import { useQuery } from 'hooks';
import {
    selectPosition5Banner,
    selectPosition9Banner,
} from 'store/ducks/banners/selectors';
import { PageMeta, Promo, Subscription } from 'components';
import { useHistory } from 'react-router-dom';

type Props = {
    match: any;
};

let send = false;

export default function Materials(props: Props) {
    let history = useHistory();

    // const search = useLocation().search;

    // if (location.search && location.search.length > 0){
    //   url = new URLSearchParams(location.search);
    // }

    const [page, setPage] = useState(1);
    const [searchForm, setSearchForm] = useState({
        query: '',
        // query: new URLSearchParams(search).get('search') && new URLSearchParams(search).get('search') || '',
        sort_column: 'created_at',
    });
    const status = useSelector(
        (state: { materials: { status: string } }) => state.materials.status
    );
    const materials = useSelector(materialsSelector);
    const materialsPaginate = useSelector(
        (state: { materials: { paginate: any } }) => state.materials.paginate
    );

    const position5Banner = useSelector(selectPosition5Banner);
    const position9Banner = useSelector(selectPosition9Banner);

    const dispatch = useDispatch();

    const handleSearch = (e: any) => {
        e.preventDefault();

        setPage(1);
        dispatch(getMaterialsClear());
        dispatch(
            getMaterials({
                ...searchForm,
                offset: '0',
                page: 1,
            })
        );

        history.replace('/materials?search=' + searchForm['query']);
    };

    const handleScroll = (event: any) => {
        if (!send) {
            if (
                event.target.documentElement.scrollHeight -
                    window.innerHeight -
                    window.scrollY <
                window.innerHeight
            ) {
                if (materialsPaginate && materialsPaginate.current_page) {
                    if (
                        materialsPaginate.total_pages !==
                        materialsPaginate.current_page
                    ) {
                        if (status == 'IDLE') {
                            dispatch(
                                getMaterials({
                                    ...searchForm,
                                    offset: '' + materials.length,
                                    page: page + 1,
                                })
                            );
                            setPage(page + 1);
                            send = true;
                        }
                    }
                } else {
                    if (
                        materialsPaginate &&
                        materialsPaginate.total_posts !== materials.length
                    ) {
                        if (status == 'IDLE') {
                            dispatch(
                                getMaterials({
                                    ...searchForm,
                                    offset: '' + materials.length,
                                    page: page + 1,
                                })
                            );
                            setPage(page + 1);
                            send = true;
                        }
                    }
                }
            }
        }
    };

    // useEffect(() => {
    //     if (location.search && location.search.length > 0) {
    // setSearchForm({
    //     ...searchForm,
    //     query: decodeURIComponent(location.search.split('=')[1]),
    // });

    // if (status == 'IDLE') {
    //     setPage(1);
    //     dispatch(getMaterialsClear());
    //     dispatch(
    //         getMaterials({
    //             ...searchForm,
    //             query: decodeURIComponent(
    //                 location.search.split('=')[1]
    //             ),
    //             offset: '0',
    //             page: 1,
    //         })
    //     );
    // }
    // }
    // }, [location.search]);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [status]);

    useEffect(() => {
        if (status == 'SUCCESS') {
            dispatch(getMaterialsIdle());
            send = false;
        }
    }, [status]);

    // useEffect(() => {
    //     if (status == 'IDLE') {
    //         setPage(1);
    //         dispatch(getMaterialsClear());
    //         dispatch(
    //             getMaterials({
    //                 ...searchForm,
    //                 offset: '0',
    //                 page: 1,
    //             })
    //         );
    //     }
    // }, [searchForm.sort_column]);

    useEffect(() => {
        document.getElementById('search-input').focus();

        if (status == 'IDLE') {

            let searchQuery =
                (location.search &&
                    decodeURIComponent(location.search.split('=')[1]).length &&
                    decodeURIComponent(location.search.split('=')[1])) ||
                '';

            setSearchForm({
                ...searchForm,
                query: searchQuery,
            });

            setPage(1);
            dispatch(getMaterialsClear());
            dispatch(
                getMaterials({
                    ...searchForm,
                    query: searchQuery,
                    offset: '0',
                    page: 1,
                })
            );
        }
    }, []);

    return (
        <>
            <PageMeta
                title="Материалы"
                description="Telesputnik.ru является одним из самых авторитетных и быстроразвивающихся интернет-порталов в области телевизионной индустрии, рынка OTT, медиапотребления и производства контента."
                url={`https://telesputnik.ru${props.match.url}`}
            />
            <main className="page page-materials container container--page">
                <div className="page-materials-header page-materials__header">
                    <h2 className="page-title page-materials-header__title">
                        Материалы
                    </h2>
                    <div className="search search--materials page-materials-header__search">
                        <form
                            className="search__form"
                            action="#"
                            onSubmit={handleSearch}
                        >
                            <input
                                className="search__input"
                                value={searchForm['query']}
                                type="text"
                                id="search-input"
                                placeholder="Поиск по названию или тегу материала, например, интервью"
                                onChange={e => {
                                    setSearchForm({
                                        ...searchForm,
                                        query: e.target.value,
                                    });
                                }}
                            />
                            <button
                                className="search__btn"
                                type="submit"
                                onSubmit={handleSearch}
                            >
                                <svg className="search__icon">
                                    <use href="/img/sprite.svg#icons--search"></use>
                                </svg>
                            </button>
                        </form>
                    </div>
                    <Select
                        defaultValue={{
                            value: 'publication_at',
                            label: 'По дате',
                        }}
                        onChange={(e: any) => {
                            setSearchForm({
                                ...searchForm,
                                sort_column: e.value,
                            });
                            if (status == 'IDLE') {
                                setPage(1);
                                dispatch(getMaterialsClear());
                                dispatch(
                                    getMaterials({
                                        ...searchForm,
                                        sort_column: e.value,
                                        offset: '0',
                                        page: 1,
                                    })
                                );
                            }
                        }}
                        options={[
                            { value: 'created_at', label: 'По дате' },
                            { value: 'title', label: 'По заголовку' },
                        ]}
                    />
                </div>
                {materials && materials.length > 0 && (
                    <div className="page-materials-body page-materials__body">
                        <ul className="page-materials-body__list">
                            {materials[0] && (
                                <li className="page-materials-body__item page-materials-body__item--m">
                                    <article className="page-materials-card">
                                        <MaterialsCard {...materials[0]} />
                                    </article>
                                </li>
                            )}
                            {materials[1] && (
                                <li className="page-materials-body__item page-materials-body__item--m">
                                    <article className="page-materials-card">
                                        <MaterialsCard {...materials[1]} />
                                    </article>
                                </li>
                            )}
                            {materials[2] && (
                                <li className="page-materials-body__item page-materials-body__item--m">
                                    <article className="page-materials-card">
                                        <MaterialsCard {...materials[2]} />
                                    </article>
                                </li>
                            )}
                            {materials[3] && (
                                <li className="page-materials-body__item page-materials-body__item--xl">
                                    <article className="page-materials-card  page-materials-card--text-right">
                                        <MaterialsCardText {...materials[3]} />
                                    </article>
                                </li>
                            )}
                            {materials[4] && (
                                <li className="page-materials-body__item page-materials-body__item--l">
                                    <article className="page-materials-card">
                                        <MaterialsCard {...materials[4]} />
                                    </article>
                                </li>
                            )}
                            {materials[5] && (
                                <li className="page-materials-body__item page-materials-body__item--m">
                                    <article className="page-materials-card">
                                        <MaterialsCard {...materials[5]} />
                                    </article>
                                </li>
                            )}
                            <li className="page-materials-body__item page-materials-body__item--xl">
                                {position5Banner && (
                                    <Promo
                                        type="top"
                                        img={position5Banner.img}
                                        tag=""
                                        link={position5Banner.url}
                                        html={position5Banner.html}
                                        id="position5Banner"
                                        target={
                                            'position5Banner_' +
                                            position5Banner.id
                                        }
                                    />
                                )}
                            </li>
                            <li className="page-materials-body__item page-materials-body__item--xl page-materials-body__item--subscription">
                                <Subscription mod="" page="article-others" />
                            </li>
                            {materials[6] && (
                                <li className="page-materials-body__item page-materials-body__item--m">
                                    <article className="page-materials-card">
                                        <MaterialsCardText2 {...materials[6]} />
                                    </article>
                                </li>
                            )}
                            {materials[7] && (
                                <li className="page-materials-body__item page-materials-body__item--m">
                                    <article className="page-materials-card">
                                        <MaterialsCardText2 {...materials[7]} />
                                    </article>
                                </li>
                            )}
                            {materials[8] && (
                                <li className="page-materials-body__item page-materials-body__item--m">
                                    <article className="page-materials-card page-materials-card--text-bottom">
                                        <MaterialsCardText2 {...materials[8]} />
                                    </article>
                                </li>
                            )}
                            {materials[9] && (
                                <li className="page-materials-body__item page-materials-body__item--l page-materials-body__item--post">
                                    <article className="post post--articles">
                                        <PostArticles {...materials[9]} />
                                    </article>
                                </li>
                            )}
                            {materials.length > 10 && (
                                <li className="page-materials-body__item page-materials-body__item--vertical">
                                    {position9Banner && (
                                        <Promo
                                            type="articles"
                                            img={position9Banner.img}
                                            tag=""
                                            link={position9Banner.url}
                                            html={position9Banner.html}
                                            id="position9Banner"
                                            target={
                                                'position9Banner_' +
                                                position9Banner.id
                                            }
                                        />
                                    )}
                                </li>
                            )}
                            {materials[10] && (
                                <li className="page-materials-body__item page-materials-body__item--l">
                                    <article className="post post--articles post--articles-yellow">
                                        <PostArticles {...materials[10]} />
                                    </article>
                                </li>
                            )}
                            {materials[11] && (
                                <li className="page-materials-body__item page-materials-body__item--xl">
                                    <article className="page-materials-card page-materials-card--text-right">
                                        <MaterialsCardText {...materials[11]} />
                                    </article>
                                </li>
                            )}
                            {materials.length > 12 &&
                                materials.map((item, index) => {
                                    if (index > 11) {
                                        if (index % 3 == 0) {
                                            return (
                                                <li className="page-materials-body__item page-materials-body__item--l">
                                                    <article className="page-materials-card">
                                                        <MaterialsCard
                                                            {...item}
                                                        />
                                                    </article>
                                                </li>
                                            );
                                        } else if (index % 3 == 1) {
                                            return (
                                                <li className="page-materials-body__item page-materials-body__item--m">
                                                    <article className="page-materials-card">
                                                        <MaterialsCard
                                                            {...item}
                                                        />
                                                    </article>
                                                </li>
                                            );
                                        } else {
                                            return (
                                                <li className="page-materials-body__item page-materials-body__item--xl">
                                                    <article className="page-materials-card page-materials-card--text-right">
                                                        <MaterialsCardText
                                                            {...item}
                                                        />
                                                    </article>
                                                </li>
                                            );
                                        }
                                    }
                                })}
                        </ul>
                    </div>
                )}
                {/* <Media /> */}
            </main>
        </>
    );
}
